import React from 'react';

const BetsClosingPopUp = ({ decidePopUpContent }) => {
  return (
    <div className='bets-are-closing-wrp' title={decidePopUpContent()}>
      <div className='bets-are-closing-inner'>
        <p className='bets-are-closing-txt'>{decidePopUpContent()}</p>
      </div>
    </div>
  );
};

export default BetsClosingPopUp;
